<template>
  <section class="pkey-contain">
    <section class="pkey-keyboard">
      <header class="pkey-header2">
        <label class="pkey-chacelbtn" @click="handleCancel">取消</label>
        <label class="pkey-okbtn" @click="handleComplete">完成</label>
      </header>
      <section class="pkey-keyscontain">
        <ul>
          <li
            v-show="provinceBoardShow"
            v-for="(item, index) in provinceData"
            :key="index"
          >
            <span
              v-show="index === provinceData.length - 1"
              @click="(provinceBoardShow = false), (numBoardShow = true)"
            >
              ABC
            </span>
            <label
              v-for="(items, indexi) in item"
              :key="'province' + indexi"
              @click="txtclick(items)"
            >
              {{ items }}
            </label>
            <span
              class="iconfont iconshanchu"
              v-show="index === provinceData.length - 1"
              @click="deletePlate"
            >
            </span>
          </li>
          <li
            v-show="numBoardShow"
            v-for="(item, index) in numData"
            :key="'num' + index"
          >
            <span
              v-show="index === provinceData.length - 1"
              @click="(provinceBoardShow = true), (numBoardShow = false)"
            >
              字
            </span>
            <label
              v-for="(items, indexi) in item"
              :key="'num1' + indexi"
              @click="numclick(items)"
            >
              {{ items }}
            </label>
            <span
              class="iconfont iconshanchu"
              v-show="index === provinceData.length - 1"
              @click="deletePlate"
            >
            </span>
          </li>
        </ul>
      </section>
    </section>
  </section>
</template>
<script>
import "@/icons/iconfont.css";
export default {
  data() {
    return {
      plateNum: "",
      provinceBoardShow: true,
      numBoardShow: false,
      provinceData: [
        ["京", "津", "渝", "沪", "冀", "晋", "辽", "吉", "黑", "苏"],
        ["浙", "皖", "闽", "赣", "鲁", "豫", "鄂", "湘", "粤", "琼"],
        ["川", "贵", "云", "陕", "甘", "青", "蒙", "桂", "宁", "新"],
        ["藏", "使", "领", "警", "学", "港", "澳"]
      ],
      numData: [
        ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
        ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
        ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
        ["Z", "X", "C", "V", "B", "N", "M"]
      ]
    };
  },
  methods: {
    // 省份
    txtclick(province) {
      if (this.plateNum.length > 6) {
        return;
      }
      this.provinceBoardShow = false;
      this.numBoardShow = true;
      this.plateNum += province;
      this.$emit("handlePlateNum", this.plateNum);
    },
    // 数字
    numclick(num) {
      if (this.plateNum.length > 6) {
        return;
      }
      this.plateNum += num;
      this.$emit("handlePlateNum", this.plateNum);
    },
    // 删除按钮
    deletePlate() {
      this.plateNum = this.plateNum.substr(0, this.plateNum.length - 1);
      this.$emit("handlePlateNum", this.plateNum);
      if (this.plateNum.length === 0) {
        this.provinceBoardShow = true;
        this.numBoardShow = false;
      }
    },
    // 完成按钮
    handleComplete() {
      if (this.plateNum == "") {
        this.$toast("请输入车牌号码");
        return;
      }
      if (
        !/^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[警京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼]{0,1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}[A-Z0-9]{0,1}[A-Z0-9]{0,1}$/.test(
          this.plateNum
        )
      ) {
        this.$toast("车牌号格式不正确");
        return;
      }
      this.$emit("handlePlateNum", this.plateNum);
      this.plateNum = "";
      this.provinceBoardShow = true;
      this.numBoardShow = false;
    },
    // 取消按钮
    handleCancel() {
      this.plateNum = "";
      this.provinceBoardShow = true;
      this.numBoardShow = false;
      this.$emit("closeKeyBoard", false);
    }
  }
};
</script>
<style lang="scss" scoped>
.pkey-keyboard {
  position: fixed;
  bottom: 0;
  width: 100%;

  .pkey-header2 {
    display: flex;
    justify-content: space-around;
    height: 30px;
    line-height: 30px;
    background-color: #f4f4f6;
    color: blue;
  }

  .pkey-keyscontain {
    padding: 10px;
    background-color: #d1d5da;

    ul li {
      display: flex;
      justify-content: space-between;
      height: 30px;
      margin-bottom: 10px;
      line-height: 30px;

      span {
        display: flex;
        align-items: center;
        padding: 5px;
        background-color: #fff;
      }

      label {
        display: flex;
        align-items: center;
        padding: 5px;
        background-color: #fff;
        border-radius: 5px;
      }
    }

    ul li:nth-child(4),
    ul li:nth-child(8) {
      margin-bottom: 0;
    }
  }
}
</style>
